/**
 * tax/loanKey.ts — 팀장님 대출 링크 「보낸 대출 진행 보기」 열쇠를 이 기기에 둔다 (2026-10-28 지도사 「팀장님이 쓰시는 건 이런 허들 없애」)
 *  열쇠가 오는 곳 ① 팀장님께 보낸 「직접 입력하실 때」 주소 ?k=  ② 팀장님 포털(열면 이 기기에 둔다 · 같은 도메인)
 *  열쇠가 있으면 인증번호 없이 바로 · 서버 services/fpLoanView.loanKey(링크 토큰을 새로 만들면 바뀜)
 */
const name = (token: string) => `loanKey:${token}`;

export function saveLoanKey(token: string, key: string): void {
  if (!token || !key) return;
  try { localStorage.setItem(name(token), key); } catch { /* 저장이 막힌 브라우저 — 이번엔 주소 열쇠로만 */ }
}
export function readLoanKey(token: string): string {
  try { return localStorage.getItem(name(token)) || ''; } catch { return ''; }
}
export function dropLoanKey(token: string): void {
  try { localStorage.removeItem(name(token)); } catch { /* 그대로 */ }
}
/** 주소의 ?k= 를 이 기기에 두고 주소창에서는 뺀다(복사 · 공유로 열쇠가 대표님께 가지 않게) — 열쇠 또는 '' */
export function takeKeyFromUrl(token: string): string {
  try {
    const u = new URL(window.location.href);
    const k = u.searchParams.get('k') || '';
    if (!k) return '';
    saveLoanKey(token, k);
    u.searchParams.delete('k');
    window.history.replaceState(window.history.state, '', u.pathname + (u.search || '') + u.hash);
    return k;
  } catch { return ''; }
}
